import React, { Component } from 'react';
import msSalService from '../../services/msSalService';
import TimeoutModal from './TimeoutModal';
import { clearLocalStorage, parseQueryString } from '../../utils/helpers';

class LogOutPage extends Component {
    constructor() {
        super();
        this.state = {
            redirecturl: undefined,
            showModal: true,
        };
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        const queryString = window.location.hash.split('?')[1];
        const parsedQueryString = parseQueryString(queryString);
        // this.authenticationLogOut(parsedQueryString.url);
        localStorage.removeItem('LocalStorage_UserSignedIN');
        localStorage.removeItem('LocalStorage_FirstTimeUserLogin');
        localStorage.removeItem('LocalStorage_PersonalInfoDisclaimerAlert');
        localStorage.removeItem('snoozeNotification');

        msSalService.clearAuthInfo();
        msSalService.fireLogOutEvent();
        if (parsedQueryString.action === 'sessiontimeout' || parsedQueryString.action === 'user') {
            this.setState({
                redirecturl: encodeURI(
                    `${process.env.REACT_APP_LT_API_URI}/Resources/Security/LogoutApplication?url=${process.env.REACT_APP_LOGIN_URL}`
                ),
            });
        } else if (
            parsedQueryString.action === 'jobboard' ||
            parsedQueryString.action === 'jobboardRedirect'
        ) {
            this.setState({
                redirecturl: parsedQueryString.url,
            });
        }
    }

    redirectToLogin = () => {
        this.setState({ showModal: false });
        msSalService.redirectToSignIn();
    };

    toggleLogoutDialog = () => {
        msSalService.redirectToSignIn();
    };

    renderLoggedoutDialog = () => {
        const { showModal } = this.state;
        clearLocalStorage();
        return (
            <TimeoutModal
                showModal={showModal}
                handleSignin={this.redirectToLogin}
                togglePopup={this.toggleLogoutDialog}
            />
        );
    };

    render() {
        const { redirecturl } = this.state;

        const queryString = window.location.hash.split('?')[1];
        const parsedQueryString = parseQueryString(queryString);
        const reasonFlag = localStorage.getItem('LocalStorage_Reason');
        if (
            parsedQueryString.action === 'sessiontimeout' &&
            reasonFlag &&
            reasonFlag === 'timesup'
        ) {
            return <>{this.renderLoggedoutDialog()}</>;
        }

        if (redirecturl) {
            clearLocalStorage();
            window.location = redirecturl;
            return null;
        }
        clearLocalStorage();
        return null;
    }
}

export default LogOutPage;
